export const APP_VERSION = "26.3.5.1";

export enum COUNTRY_CODE {
  co = "CO",
  pe = "PE",
  br = "BR",
  cl = "CL",
  cr = "CR",
  uy = "UY",
  ar = "AR",
  mx = "MX",
  ec = "EC",
}

export type EnvironmentType = {
  placement: "dev" | "prod";
  production: boolean;
  route_hash: boolean;
  timezone: string;
  code: COUNTRY_CODE;
  currency: string;
  grammar: string;
  lang: "es" | "pt";
  phone_length: number;
  max_phone_length?: number;
  max_tip: number;
  phone_prefix: string;
  gateway: {
    base_url: string;
    gateway_prefix: string;
    location_gateway_prefix: string;
    settlement_prefix: string;
    csv_prefix: string;
  };
  logoUrl: string;
  maps_api: {
    api_key: string;
  };
  coordsCenter: { lat: number; lng: number };
  currencySymbol: string;
  decimalPattern: RegExp;
  decimalNumber: number;
  country: {
    defaultLocale: string;
  };
  trackingUrl: string;
  localeUrl: string;
  auth0: {
    client_id: string;
    client_secret: string;
    domain: string;
  };
  amplitude: {
    key: string;
  };
  OAuthGateway: string;
  i18n_version: string;
  kustomer_assistant_id: string;
};
